module.exports = __webpack_public_path__ + "img/demo3.61bf10d9.png";